import { FC, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import { Task } from '@payaca/types/taskTypes';
import ViewCompleteTaskControl from '../viewCompleteTaskControl/ViewCompleteTaskControl';
import './ViewCompleteTaskModal.sass';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onUpdateTaskCompletionSuccess?: () => void;
  task: Task;
};
const ViewCompleteTaskModal: FC<Props> = ({
  isOpen,
  onClose,
  onUpdateTaskCompletionSuccess,
  task,
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      className="view-complete-task-modal"
      title={task.name}
      onClose={onClose}
    >
      <Modal.Body>
        <ViewCompleteTaskControl
          task={task}
          onUpdateTaskCompletionSuccess={onUpdateTaskCompletionSuccess}
        />
      </Modal.Body>
    </Modal>
  );
};
export default ViewCompleteTaskModal;
